import { ServiceName } from '@kmns-internal/app-launcher'
import { ContractService } from '@ulysses-inc/harami_api_client'

/**
 * ContractService から ServiceName への変換マップ
 *
 * このマッパーは外部ライブラリ間の型変換を担当します。
 * 新しいサービスが ContractService に追加された場合、
 * ここで型エラーが発生します。
 *
 * @param service - 変換元の ContractService
 * @returns 対応する ServiceName、または変換できない場合は null
 */
export const contractServiceToServiceName = (
  service: ContractService,
): ServiceName | null => {
  switch (service) {
    case ContractService.report:
      return 'report'
    case ContractService.employee:
      return 'employee'
    case ContractService.cmms:
      return 'cmms'
    case ContractService.training:
      return 'training'
    case ContractService.tracker:
      return 'tracker'
    case ContractService.leaved:
      // "leaved" は ServiceName に存在しないため null を返す
      return null
    default:
      // API クライアントの更新前に API が新しいサービスを返しても
      // グローバルナビゲーションが描画できなくならないよう、実行時は null を返す。
      // 型レベルの網羅性チェックは維持し、ContractService に値が追加されたらここで型エラーになる。
      service satisfies never
      return null
  }
}

/**
 * ContractService配列 から ServiceName配列 への変換
 * null値は自動的にフィルタリングされます
 *
 * @param services - 変換元の ContractService 配列
 * @returns 変換された ServiceName 配列（null値は除外）
 */
export const mapContractServicesToServiceNames = (
  services: ContractService[],
): ServiceName[] => {
  return services
    .map(contractServiceToServiceName)
    .filter((service): service is ServiceName => service !== null)
}
